export class TranslationErrorHandler {
  static handleLocalLoadError(scope: string, lang: string, error: any): void {
    // eslint-disable-next-line no-console
    console.warn(
      `Failed to load ${scope} translation for ${lang} from local asset:`,
      error,
    );
  }

  static handleBlobLoadError(scope: string, lang: string, error: any): void {
    // eslint-disable-next-line no-console
    console.warn(
      `Failed to load ${scope} translation for ${lang} from blob storage:`,
      error,
    );
  }

  static handleFallbackError(lang: string, error: any): void {
    // eslint-disable-next-line no-console
    console.error(`Failed to load fallback translation for ${lang}:`, error);
  }

  static handleScopeMappingError(scope: string, lang: string): Error {
    const error = new Error(`No import mapping defined for scope: ${scope}`);
    // eslint-disable-next-line no-console
    console.warn(
      `Failed to load ${scope} translation for ${lang} from local asset:`,
      error,
    );

    return error;
  }

  static logLocalTranslationError(lang: string, error: any): void {
    // eslint-disable-next-line no-console
    console.warn(`Failed to load local translation for ${lang}:`, error);
  }

  static logEnglishLoadWarning(): void {
    // eslint-disable-next-line no-console
    console.warn('Failed to load English from blob, trying local asset');
  }

  static logEnglishLoadError(error: any): void {
    // eslint-disable-next-line no-console
    console.error('Failed to load English translation:', error);
  }

  static logBlobFallbackWarning(lang: string, error: any): void {
    // eslint-disable-next-line no-console
    console.warn(
      `Failed to load translation from blob storage for ${lang}, falling back to English assets:`,
      error,
    );
  }
}
